
import Vue, { PropType } from "vue";
import { dispatch, Order } from "@/store";

export default Vue.extend({
  name: "VOrderShipping",
  props: {
    order: Object as PropType<Order>
  },
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      lodaing: false
    };
  },
  methods: {
    onShippingChange() {
      this.visible = true;
      setTimeout(() => {
        this.form.resetFields();
        this.form.setFieldsValue({
          order: this.order,
          // amount: order.order.amount,
          shipping: this.order.order.shipping
        });
      }, 200);
    },
    onOk() {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          const order = values.order;
          this.lodaing = true;
          // order.order.amount = values.amount;
          order.order.shipping = values.shipping;
          dispatch
            .ordersAmountPatch(order)
            .then(() => {
              this.visible = false;
              this.lodaing = false;
              this.$message.success("运费修改成功");
              this.$emit("change");
            })
            .catch(() => {
              this.lodaing = false;
            });
        }
      });
    }
  }
});
